export interface UrlData {
  url: string | null | undefined;
  passPNG?: boolean;
  jpgSettings?: string[];
}

export const updateImageUrl = (data: UrlData) => {
  const { url, passPNG, jpgSettings } = data;
  if (!url) {
    return '';
  }
  if (passPNG) {
    const testUrl = url.toLowerCase();
    if (testUrl.includes('inputformat=png')) {
      return `${url}&imageFormat=png`;
    }
  }
  if (jpgSettings && jpgSettings.length > 0) {
    const settings = jpgSettings.join('&');

    return `${url}&${settings}`;
  }

  return url;
};
